import { api } from '@common';
import { CardForm } from '@components/atoms';
import { PencilSimple } from '@phosphor-icons/react';
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import { Button, Input } from 'antd';
import { useState } from 'react';

interface CustomerNotesProps {
    customerId: string;
    initialNotes: string;
    lastUpdatedNotes: string;
    onRefetch: (options?: RefetchOptions | undefined) => Promise<QueryObserverResult<any, Error>>;
}

export const CustomerNotes = ({
    customerId,
    initialNotes,
    lastUpdatedNotes,
    onRefetch
}: CustomerNotesProps) => {
    const [isEditing, setIsEditing] = useState(false);
    const [tempAnnotations, setTempAnnotations] = useState(initialNotes);

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSave = async () => {
        try {
            await api.patch(`/customer/${customerId}/notes`, {
                notes: tempAnnotations,
                lastUpdatedNotes: new Date().toISOString()
            });

            setIsEditing(false);
            await onRefetch();
        } catch (error) {
            console.error('Erro ao atualizar anotações:', error);
        }
    };

    const handleCancel = () => {
        setTempAnnotations(initialNotes);
        setIsEditing(false);
    };

    return (
        <CardForm>
            <div className='relative'>
                <h2 className='text-lg font-semibold mb-4'>Anotações</h2>
                <span className='absolute top-0 right-0'>
                    <Button
                        icon={<PencilSimple />}
                        type='primary'
                        size='large'
                        disabled={isEditing}
                        onClick={!isEditing ? handleEditClick : undefined}
                    />
                </span>
                <div className='flex flex-col md:flex-row gap-4'>
                    <div className='flex-1'>
                        <CardForm
                            variant={isEditing ? 'default' : 'dotted'}
                            className='!p-0'
                        >
                            {isEditing ? (
                                <Input.TextArea
                                    value={tempAnnotations}
                                    onChange={(e) => setTempAnnotations(e.target.value)}
                                    autoSize={{ minRows: 4, maxRows: 8 }}
                                    className='text-xs p-2 h-full, min-h-24'
                                />
                            ) : (
                                <div className='whitespace-pre-wrap text-xs text-gray-500 p-2 min-h-24'>
                                    {initialNotes}
                                </div>
                            )}
                        </CardForm>
                    </div>
                    <div className='flex-col w-40 text-left '>
                        <div className='text-xs text-gray-500'>
                            Última atualização em
                        </div>
                        <div className={`text-xs text-left font-semibold ${isEditing ? '!text-gray-500' : '!text-gray-900'}`}>
                            {lastUpdatedNotes}
                        </div>
                    </div>
                </div>
            </div>
            {isEditing && (
                <div className='text-left mt-4'>
                    <Button type='primary' onClick={handleSave}>
                        Salvar
                    </Button>
                    <Button type='primary' ghost className='ml-2' onClick={handleCancel}>
                        Cancelar
                    </Button>
                </div>
            )}
        </CardForm>
    );
}; 